<div class="modal-wrapper">
  <h1 mat-dialog-title>
    {{ confirmMode ? "Confirm your details" : "Let us know a bit about you" }}
  </h1>
  <p *ngIf="confirmMode" class="confirm-hint">
    Please review the information from your partner account. Update anything
    that is incorrect, then confirm to continue.
  </p>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="info-name">
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" required />
          <mat-error
            class="error"
            *ngIf="form.controls['firstName']?.hasError('required')"
            >First Name is required</mat-error
          >
        </mat-form-field>

        <mat-form-field>
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" required />
          <mat-error
            class="error"
            *ngIf="form.controls['lastName']?.hasError('required')"
            >Last Name is required</mat-error
          >
        </mat-form-field>
      </div>

      <div class="info-large">
        <div class="">
          <mat-form-field class="birthday">
            <mat-label
              >Date of Birth
              <span class="input-format">MM/DD/YYYY</span></mat-label
            >
            <input
              matInput
              formControlName="birthday"
              [matDatepicker]="dobPicker"
              required
              kprDateFormat
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dobPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #dobPicker></mat-datepicker>
            <mat-error
              class="error"
              *ngIf="form.controls['birthday']?.hasError('required')"
              >Date of Birth is required</mat-error
            >
          </mat-form-field>
          <mat-form-field class="phone" [floatLabel]="'always'">
            <mat-label>Phone</mat-label>
            <ngx-intl-tel-input
              [cssClass]="'phone-input'"
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="[
                SearchCountryField.Iso2,
                SearchCountryField.Name
              ]"
              [selectFirstCountry]="false"
              [selectedCountryISO]="CountryISO.UnitedStates"
              [phoneValidation]="false"
              [separateDialCode]="false"
              [numberFormat]="PhoneNumberFormat.National"
              name="phone"
              formControlName="phone"
              (countryChange)="onCountryChange($event)"
            ></ngx-intl-tel-input>

            <input matInput formControlName="phone" style="display: none" />
          </mat-form-field>
        </div>
        <div>
          <mat-label class="gender-label">Gender *</mat-label>
          <mat-radio-group
            formControlName="gender"
            aria-label="Select your gender"
            class="gender-group"
          >
            <mat-radio-button class="gender-item" value="male"
              >Male</mat-radio-button
            >
            <mat-radio-button class="gender-item" value="female"
              >Female</mat-radio-button
            >
            <mat-radio-button class="gender-item" value="non-binary"
              >Non-binary</mat-radio-button
            >
          </mat-radio-group>
          <mat-error
            style="font-size: 75%"
            class="error"
            *ngIf="
              form.get('gender')?.hasError('required') &&
              form.get('gender')?.touched
            "
            >Gender is required</mat-error
          >
        </div>
      </div>
      <div class="location-row">
        <mat-form-field>
          <mat-label>State / Town / Province</mat-label>
          <input matInput formControlName="state" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Postal / Zip Code</mat-label>
          <input matInput formControlName="zipcode" />
        </mat-form-field>
      </div>
      <div class="insurance-row">
        <mat-checkbox
          class="insurance-checkbox"
          formControlName="has_insurance"
        >
          <div>Do you have insurance?</div>
        </mat-checkbox>
      </div>
      <div class="consent-row">
        <mat-checkbox class="insurance-checkbox" formControlName="consent_sms">
          <div>
            I agree to receive automated texts from KELLS regarding
            notifications related to my account or platform activity.
          </div>
        </mat-checkbox>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="onSubmit()" class="confirm-btn">
      {{ confirmMode ? "Confirm" : "Submit" }}
    </button>
  </mat-dialog-actions>
</div>
